/**
 * @name trim
 * @description Takes a string and trims off the excess white space before and after.
 * @param {string} str
 * @return {string}
 */
export function trim(str) {
  return str.replace(/^\s+|\s+$/g, '');
}

/**
 * @name trimNSplit
 * @description Splits a string on commas while triming off the excess white space before and after each entry
 * @param {string} str
 * @return {Array}
 */
export const trimNSplit = str =>
  str
    .trim()
    .split(/[\s,]+/)
    .filter(s => s);
